import ComponentLayout from "../../../../src/layouts/component-layout";
import { TestimonialQuoteMarkColors } from '@primer/react-brand';
import { Box as Container, Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  TestimonialQuoteMarkColors,
  Container,
  Label,
  PropTableValues,
  React
};